import React, { useEffect, useState, useRef } from 'react';
import { zhMap } from "./zhTranslations";


import Link from "@mui/material/Link";


import './Row.css';
import {
  Box,
  Button,
  Container,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Collapse,
  IconButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
  Snackbar,
  TextField,

} from '@mui/material';
import MuiAlert from '@mui/material/Alert';

import { KeyboardArrowDown, KeyboardArrowUp } from '@mui/icons-material';
import axios from 'axios';
import { Switch, FormControlLabel } from '@mui/material'; // Importing Switch

import printJS from 'print-js';

// ==== API base & helpers ====
const API_STATUS_BASE = 'https://api.grubify.co.uk/eposnow';
const API_ORDER_MGMT_BASE = 'https://api.grubify.co.uk/order_management';

const authHeaders = (token, appId) => ({
  'Content-Type': 'application/json',
  'Authorization': `Bearer ${token}`,
  'X-App-Id': `${appId}`,
});

// ---- Prep time calls ----
const apiGetPrepTimes = (token, appId) =>
  axios.get(`${API_ORDER_MGMT_BASE}/prep-times`, { headers: authHeaders(token, appId) });

const apiUpdatePrepTimes = (body, token, appId) =>
  axios.post(`${API_ORDER_MGMT_BASE}/prep-times`, body, { headers: authHeaders(token, appId) });

// ---- Status calls ----
const apiAcceptOrder = (orderId, body, token, appId) =>
  axios.post(`${API_STATUS_BASE}/order/${orderId}/accept`, body, { headers: authHeaders(token, appId) });

const apiRejectOrder = (orderId, body, token, appId) =>
  axios.post(`${API_STATUS_BASE}/order/${orderId}/reject`, body, { headers: authHeaders(token, appId) });

const apiDelayOrder = (orderId, body, token, appId) =>
  axios.post(`${API_STATUS_BASE}/order/${orderId}/delay`, body, { headers: authHeaders(token, appId) });

const apiReadyOrder = (orderId, body, token, appId) =>
  axios.post(`${API_STATUS_BASE}/order/${orderId}/ready`, body, { headers: authHeaders(token, appId) });

const apiOutForDelivery = (orderId, body, token, appId) =>
  axios.post(`${API_STATUS_BASE}/order/${orderId}/out-for-delivery`, body, { headers: authHeaders(token, appId) });

const apiCompleteOrder = (orderId, body, token, appId) =>
  axios.post(`${API_STATUS_BASE}/order/${orderId}/complete`, body, { headers: authHeaders(token, appId) });

function isRestaurantCurrentlyOpenByHours(restaurant) {
  if (!restaurant) return false;

  const hours = restaurant.opening_hours;
  if (!Array.isArray(hours)) return false;

  const now = new Date();
  const day = now.getDay(); // 0 = Sunday
  const nowMins = now.getHours() * 60 + now.getMinutes();

  const toMins = (t) => {
    if (!t) return null;
    const [h, m] = t.split(":").map(Number);
    if (Number.isNaN(h) || Number.isNaN(m)) return null;
    return h * 60 + m;
  };

  const today = hours.filter((h) => h.DayOfWeek === day);
  const yesterday = (day + 6) % 7;

  // e.g. 18:00–02:00 (overnight)
  const yesterdaysOvernights = hours
    .filter((h) => h.DayOfWeek === yesterday)
    .filter((h) => {
      const o = toMins(h.OpenTime);
      const c = toMins(h.CloseTime);
      if (o == null || c == null) return false;
      return c <= o;
    });

  const isWithin = (open, close) => {
    const o = toMins(open);
    const c = toMins(close);
    if (o == null || c == null) return false;

    // normal same-day range
    if (c > o) return nowMins >= o && nowMins < c;
    // crosses midnight
    return nowMins >= o || nowMins < c;
  };

  return [...today, ...yesterdaysOvernights].some((h) =>
    isWithin(h.OpenTime, h.CloseTime)
  );
}

const parsePossiblyBrokenItems = (raw) => {
  if (!raw) return [];
  if (Array.isArray(raw)) return raw;

  let s = String(raw);

  // 1) Fix modifiersKey being a JSON string containing an array
  s = s.replace(
    /"modifiersKey":"(\[.*?\])"/g,
    (_, arrayStr) => `"modifiersKey":${arrayStr}`
  );

  // 2) Fix literal newlines inside JSON strings
  s = s.replace(/\n/g, "\\n");

  // 3) Fix unescaped inch quotes in names: "name":"7" Cheesy..." -> "name":"7\" Cheesy..."
  // IMPORTANT: keep the space after it
  s = s.replace(
    /"name":"([^"]*?)"([^,}\]])/g,
    (_, before, after) => `"name":"${before}\\"${after}`
  );

  return JSON.parse(s);
};




const LandingScreen = ({ auth, APP_ID }) => {
  const [orders, setOrders] = useState([]);
  const [openRow, setOpenRow] = useState(null);
  const [completedOrders, setCompletedOrders] = useState([]);
  const [newOrders, setNewOrders] = useState([]);

  const previousOrdersRef = useRef([]);
  const firstLoadRef = useRef(true);
  const token = process.env.REACT_APP_OMS_TOKEN;

  const [isToggled, setIsToggled] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const audioRef = useRef(null);
  const soundLoopRef = useRef(null);
  const [soundPromptOpen, setSoundPromptOpen] = useState(true);
  const [soundEnabled, setSoundEnabled] = useState(false);
  const [aboutOpen, setAboutOpen] = useState(false);

  const appId = APP_ID.APP_ID;


  //Opening hours
  const [restaurant, setRestaurant] = useState(null);
  const [isWithinOpeningHours, setIsWithinOpeningHours] = useState(true);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'warning',
  });

  // Prep time state
  const [pickupMinutes, setPickupMinutes] = useState('');
  const [deliveryMinutes, setDeliveryMinutes] = useState('');

  //Button safety
  const closeAccept = () => { setAcceptOpen(false); setAcceptReadyAt(''); setActionOrder(null); };
  const closeReject = () => { setRejectOpen(false); setRejectReason(''); setActionOrder(null); };
  const closeDelay = () => { setDelayOpen(false); setDelayMinutes(''); setActionOrder(null); };

  // Track previous opening hours state to handle transitions
  const prevWithinOpeningHours = useRef(isWithinOpeningHours);


  // Dialog state
  const [rejectOpen, setRejectOpen] = useState(false);
  const [delayOpen, setDelayOpen] = useState(false);
  const [prepOpen, setPrepOpen] = useState(false);
  const [acceptOpen, setAcceptOpen] = useState(false);
  const [actionOrder, setActionOrder] = useState(null);

  // Dialog form fields
  const [rejectReason, setRejectReason] = useState('');
  const [delayMinutes, setDelayMinutes] = useState('');

  const [acceptReadyAt, setAcceptReadyAt] = useState('');     // datetime-local (pickup hint)


  const [printZh, setPrintZh] = useState(false);
  const isPickup = (o) => String(o.fulfilmentType || '').toLowerCase() === 'pickup';
  const isDelivery = (o) => String(o.fulfilmentType || '').toLowerCase() === 'delivery';

  const canMarkReady = (o) =>
    isPickup(o) && (o.status === "ACCEPTED" || o.status === "DELAYED");

  const canOutForDelivery = (o) =>
    isDelivery(o) && (o.status === "ACCEPTED" || o.status === "DELAYED");

  const canCompletePickup = (o) => isPickup(o) && o.status === "READY";
  const canCompleteDelivery = (o) => isDelivery(o) && o.status === "OUT_FOR_DELIVERY";




  const handleSavePrepTimes = async () => {
    const pickup = Number(pickupMinutes);
    const delivery = Number(deliveryMinutes);

    // basic safety check in case something weird gets through
    if (!Number.isFinite(pickup) || !Number.isFinite(delivery)) {
      setSnackbar({
        open: true,
        message: 'Pickup and delivery times must be numbers.',
        severity: 'warning',
      });
      return;
    }

    if (pickup <= 0) {
      setSnackbar({
        open: true,
        message: 'Pickup time must be > 0 minutes.',
        severity: 'warning',
      });
      return;
    }

    if (delivery <= 0) {
      setSnackbar({
        open: true,
        message: 'Delivery time must be > 0 minutes.',
        severity: 'warning',
      });
      return;
    }

    try {
      await apiUpdatePrepTimes(
        {
          pickup,   // ✅ exactly what backend expects
          delivery,
        },
        token,
        appId
      );

      setSnackbar({
        open: true,
        message: 'Prep times updated successfully.',
        severity: 'success',
      });
      setPrepOpen(false); // Close dialog on success
    } catch (e) {
      console.error('Error updating prep times', e);
      setSnackbar({
        open: true,
        message: 'Error updating prep times. Please try again.',
        severity: 'error',
      });
    }
  };






  const acceptOrder = async (o) => {
    if (!o?.id) return;
    try {
      await apiAcceptOrder(
        o.id,
        {
          // pass fulfillmentType if you want; backend also resolves it by orderId
          fulfillmentType: o.fulfilmentType,
          readyAt: acceptReadyAt ? new Date(acceptReadyAt).toISOString() : null,
        },
        token, appId
      );

      setOrders(prev =>
        prev.map(x =>
          x.id === o.id
            ? { ...x, status: "ACCEPTED" }
            : x
        )
      );
      closeAccept();
    } catch (e) {
      console.error('accept error', e);
    }
  };

  const rejectOrder = async (o) => {
    if (!o?.id) return;

    try {
      // 1) Legacy cancel + refund (DO NOT CHANGE BACKEND)
      await axios.post(
        'https://api.grubify.co.uk/order_management/cancel',
        { orderId: o.id },
        { headers: authHeaders(token, appId) }
      );

      // optional UI state if you want
      // setCancelledOrders(prev => [...prev, o.id]);

      // 2) Publish REJECTED to status service (customer tracking)
      await axios.post(
        `${API_STATUS_BASE}/order/${o.id}/reject`,
        {
          reason: rejectReason || 'Cancelled by restaurant',
          fulfillmentType: o?.fulfilmentType, // backend can infer
        },
        { headers: authHeaders(token, appId) }
      );

      setOrders(prev =>
        prev.map(x =>
          x.id === o.id
            ? { ...x, status: "REJECTED" }
            : x
        )
      );

      closeReject();
    } catch (error) {
      console.error('Error rejecting order:', error);
    }
  };


  const delayOrder = async (o) => {
    if (!o?.id) return;
    if (!delayMinutes || Number(delayMinutes) <= 0) {
      setSnackbar({
        open: true,
        message: 'Please enter delay minutes',
        severity: 'warning',
      });
      return;
    }

    try {
      await apiDelayOrder(
        o.id,
        {
          extraMinutes: Number(delayMinutes),
          reason: `Delay +${delayMinutes} min`,
          fulfillmentType: o.fulfilmentType,
        },
        token,
        appId
      );

      setOrders(prev =>
        prev.map(x =>
          x.id === o.id
            ? { ...x, status: "DELAYED" }
            : x
        )
      );

      closeDelay();
    } catch (e) {
      console.error('delay error', e);
    }
  };



  const markReady = async (o) => {
    if (!o?.id) return;
    try {
      await apiReadyOrder(
        o.id,
        {
          readyAt: new Date().toISOString(), // now
          fulfillmentType: o.fulfilmentType,
        },
        token,
        appId
      );

      setOrders(prev =>
        prev.map(x =>
          x.id === o.id
            ? { ...x, status: "READY" }
            : x
        )
      );

    } catch (e) {
      console.error('ready error', e);
    }
  };


  const markOutForDelivery = async (o) => {
    if (!o?.id) return;
    if (!isDelivery(o)) return;

    try {
      await apiOutForDelivery(
        o.id,
        { fulfillmentType: o.fulfilmentType },
        token, appId
      );

      setOrders(prev =>
        prev.map(x =>
          x.id === o.id
            ? { ...x, status: "OUT_FOR_DELIVERY" }
            : x
        )
      );

    } catch (e) {
      console.error('ofd error', e);
    }
  };



  // const completeOrder = async (o) => {
  //   try {
  //     await apiCompleteOrder(
  //       o.id,
  //       { completedAt: new Date().toISOString(), note: '', fulfillmentType: o.fulfilmentType },
  //       token, appId
  //     );
  //     setCompletedOrders((prev) => [...prev, o.id]);
  //   } catch (e) {
  //     console.error('complete error', e);
  //   }
  // };



  const money = (n) => `£${(Number.isFinite(n) ? n : 0).toFixed(2)}`;
  const lineTotal = (item) => {
    // Always calculate from price × quantity to avoid stale totalPrice from cart merge bug
    const n = item?.price != null && item?.quantity != null
      ? item.price * item.quantity
      : Number(item?.totalPrice ?? 0);
    return Number.isFinite(n) ? n : 0;
  };

  // -- label helpers --
  const getVariationLabel = (obj = {}) => {
    return (
      obj.variationName ??
      obj.selectedVariationName ??
      (typeof obj.selectedVariation === "string"
        ? obj.selectedVariation
        : obj.selectedVariation?.name) ??
      (typeof obj.variation === "string" ? obj.variation : obj.variation?.name) ??
      obj.crust ??           // sometimes stored as "crust"
      obj.base ??            // sometimes stored as "base"
      null
    );
  };

  const getSizeLabel = (obj = {}) => {
    const s = obj.selectedSize ?? obj.size ?? obj.sizeName;
    if (s == null) return null;

    if (typeof s === "string") return s;        // e.g. "Large" or `10"`
    if (typeof s === "number") return `${s}"`;  // 7 -> 7"
    if (typeof s === "object") {
      if (typeof s.name === "number") return `${s.name}"`;
      return s.name ?? s.label ?? null;         // { name: "Large" }
    }
    return null;
  };

  const getAddonsLabel = (obj = {}) => {
    const list =
      obj.selectedAddons ??
      obj.addons ??
      obj.selectedToppings ??
      obj.toppings ??
      [];
    if (!Array.isArray(list) || list.length === 0) return null;

    const names = list
      .map((a) => (typeof a === "string" ? a : a?.name ?? a?.label ?? a?.title ?? null))
      .filter(Boolean);

    return names.length ? names.join(", ") : null;
  };


  const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  });








  const handleRowClick = (orderId) => {
    // Stop sound loop when user opens the order
    if (newOrders.includes(orderId)) {
      stopSoundLoop();
    }

    setOpenRow((prevOpenRow) => (prevOpenRow === orderId ? null : orderId));
    setNewOrders((prevNewOrders) => prevNewOrders.filter((id) => id !== orderId));
  };


  const handleSignOut = () => {
    auth.removeUser(); // Trigger the sign-out logic
  };

  useEffect(() => {
    const fetchRestaurant = async () => {
      if (!appId) return;

      try {
        const res = await axios.get(
          'https://api.grubify.co.uk/menu',
          { headers: authHeaders(token, appId) }
        );

        // Adjust if your API nests data, e.g. res.data.data
        const restaurantData = res.data;
        setRestaurant(restaurantData);

        // initialise flag based on hours only
        const openNow = isRestaurantCurrentlyOpenByHours(restaurantData);
        setIsWithinOpeningHours(openNow);
      } catch (e) {
        console.error('Error fetching restaurant for opening hours', e);
        // fail-open so staff are not blocked if this call dies
        setIsWithinOpeningHours(true);
      }
    };

    fetchRestaurant();
  }, [token, appId]);


  useEffect(() => {
    const fetchInitialToggleState = async () => {
      try {
        const response = await axios.get('https://api.grubify.co.uk/order_management/toggle', {
          headers: {
            'Authorization': `Bearer ${token}`,
            'X-App-Id': `${appId}`,
          },
        });

        const isAcceptingOrders = response.data?.data?.accepting_orders === 1;
        setIsToggled(isAcceptingOrders); // Sync toggle state with backend
        console.log('Fetched initial toggle state:', isAcceptingOrders ? 'On' : 'Off');
      } catch (error) {
        console.error('Error fetching initial toggle state:', error);
      }
    };

    fetchInitialToggleState();
  }, [token, appId]); // Dependencies

  useEffect(() => {
    if (!soundEnabled) {
      setSoundPromptOpen(true);
    }
  }, [soundEnabled]);

  //Timings 

  useEffect(() => {
    if (!appId) return;

    const fetchPrepTimes = async () => {
      try {
        const res = await apiGetPrepTimes(token, appId);
        const data = res.data || {};

        // backend could respond { pickup: 20, delivery: 35 }
        if (data.pickup != null) setPickupMinutes(data.pickup);
        if (data.delivery != null) setDeliveryMinutes(data.delivery);
      } catch (e) {
        console.error('Error fetching prep times', e);
        // fail silently or show warning if you like
      }
    };

    fetchPrepTimes();
  }, [appId, token]);


  // Function to handle the toggle switch and send the POST request
  const handleToggle = async (event) => {
    const newToggleState = event.target.checked;


    // ALLOW toggling even if closed (User Requirement)
    // if (newToggleState && !isWithinOpeningHours) {
    //   console.warn("Cannot open restaurant outside scheduled hours");
    //   setSnackbar({
    //     open: true,
    //     message: 'Cannot open restaurant – outside scheduled opening hours.',
    //     severity: 'warning',
    //   });
    //   return;
    // }

    setIsToggled(newToggleState);

    try {
      const response = await axios.post(
        'https://api.grubify.co.uk/order_management/toggle',
        { toggleState: newToggleState }, // Sending the state (on or off)
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`, // Using the token in the request header
            'X-App-Id': `${appId}` // Include appId as header
          },
        }
      );
      console.log('Toggle request successful:', response.data);
    } catch (error) {
      console.error('Error toggling state:', error);
      setIsToggled((prev) => !newToggleState);
      setSnackbar({
        open: true,
        message: 'Error updating restaurant status. Please try again.',
        severity: 'error',
      });
    }
  };

  useEffect(() => {
    // Only auto-close if we TRANSITION from Open -> Closed
    // This allows the user to manually toggle ON even if closed, without immediate auto-close.
    if (prevWithinOpeningHours.current && !isWithinOpeningHours && isToggled) {
      (async () => {
        try {
          await axios.post(
            'https://api.grubify.co.uk/order_management/toggle',
            { toggleState: false },
            {
              headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
                'X-App-Id': `${appId}`,
              },
            }
          );
          setIsToggled(false);
          setSnackbar({
            open: true,
            message: 'Restaurant auto-closed (end of opening hours).',
            severity: 'info',
          });
        } catch (e) {
          console.error('Error auto-closing outside opening hours', e);
        }
      })();
    }

    // Update ref for next render
    prevWithinOpeningHours.current = isWithinOpeningHours;
  }, [isWithinOpeningHours, isToggled, token, appId]);


  // Recalculate open/closed every minute based on cached restaurant hours
  useEffect(() => {
    if (!restaurant) return;

    const updateOpenFlag = () => {
      const openNow = isRestaurantCurrentlyOpenByHours(restaurant);
      setIsWithinOpeningHours(openNow);
    };

    updateOpenFlag(); // run immediately
    const id = setInterval(updateOpenFlag, 60_000); // every 60s

    return () => clearInterval(id);
  }, [restaurant]);


  const startSoundLoop = () => {
    if (soundLoopRef.current) return; // already looping

    soundLoopRef.current = setInterval(() => {
      try {
        audioRef.current?.play();
      } catch (e) { }
    }, 1500); // every 1.5 seconds (change if you want)
  };

  const stopSoundLoop = () => {
    if (soundLoopRef.current) {
      clearInterval(soundLoopRef.current);
      soundLoopRef.current = null;
    }
  };




  useEffect(() => {
    const fetchOrders = async () => {
      if (!appId) return; // Wait until appId is set
      try {
        const response = await axios.get('https://api.grubify.co.uk/order_management', {
          headers: {
            'Authorization': `Bearer ${token}`,
            'X-App-Id': `${appId}`
          },
        });

        const rawData = response.data.data;
        const parsedOrders = rawData.map((order) => {
          let itemsArray = [];
          try {
            itemsArray = parsePossiblyBrokenItems(order.items);
          } catch (error) {
            console.error("Error parsing items after patch:", order.items, error);
            itemsArray = [];
          }

          const totalValue = parseFloat(order.total) || 0;

          return {
            id: order.order_id,
            customer: order.customer_name,
            phone: order.customer_phone,
            address: order.customer_address,
            total: `£${totalValue.toFixed(2)}`,
            items: itemsArray,
            fulfilmentType: order.fulfilment_type,
            status: order.status,
            notes: order.notes || "",
            createdAt: order.created_at,
          };
        });




        // Identify new orders
        const currentOrderIds = parsedOrders.map((order) => order.id);
        const previousOrderIds = previousOrdersRef.current.map((order) => order.id);

        // 🔹 First load? Do NOT treat existing orders as new.
        if (firstLoadRef.current) {
          firstLoadRef.current = false;  // mark first load as passed
        } else {
          // 🔹 Normal behaviour: detect actual new orders
          const newOrderIds = currentOrderIds.filter(
            (id) => !previousOrderIds.includes(id)
          );

          if (newOrderIds.length > 0 && soundEnabled) {
            startSoundLoop();
          }

          // Add new IDs to flashing list
          setNewOrders((prevNewOrders) => [
            ...prevNewOrders,
            ...newOrderIds.filter((id) => !prevNewOrders.includes(id)),
          ]);
        }

        setOrders(parsedOrders);  // Update the current orders

        // Update the previous orders reference
        previousOrdersRef.current = parsedOrders;
      } catch (error) {
        console.error('Error fetching orders:', error);
      }
    };

    fetchOrders(); // Initial fetch
    const interval = setInterval(fetchOrders, 10000); // Poll every 10 seconds
    return () => {
      clearInterval(interval);   // stop polling
      stopSoundLoop();           // stop any ongoing sound loop
    };
  }, [appId, soundEnabled, token]); // No dependency on `orders`




  //   try {
  //     const response = await axios.post(
  //       'https://api.grubify.co.uk/order_management/cancel',
  //       { orderId },
  //       {
  //         headers: {
  //           'Content-Type': 'application/json',
  //           'Authorization': `Bearer ${token}`,
  //             'X-App-Id': `${appId}`  
  //         },
  //       }
  //     );
  //     console.log('Order canceled successfully:', response.data);

  //     // Add the canceled order ID to the cancelledOrders state
  //     setCancelledOrders((prev) => [...prev, orderId]);
  //   } catch (error) {
  //     console.error('Error canceling order:', error);
  //   }
  // };






  // const handleComplete = async (orderId) => {
  //   try {
  //     const response = await axios.post(
  //       'https://api.grubify.co.uk/order_management/complete',
  //       { orderId },
  //       {
  //         headers: {
  //           'Content-Type': 'application/json',
  //            'Authorization': `Bearer ${token}`,
  //              'X-App-Id': `${appId}`  

  //         },
  //       }
  //     );
  //     console.log('Order completed successfully:', response.data);

  //     // Add the completed order ID to a new state for completed orders
  //     setCompletedOrders((prev) => [...prev, orderId]);
  //   } catch (error) {
  //     console.error('Error completing order:', error);
  //   }
  // };

  const handleComplete = async (orderId, order) => {
    try {
      // 1) legacy endpoint (marks completed in your ops DB)
      const response = await axios.post(
        'https://api.grubify.co.uk/order_management/complete',
        { orderId },
        { headers: authHeaders(token, appId) }
      );
      console.log('Order completed successfully:', response.data);
      setCompletedOrders((prev) => [...prev, orderId]);

      // 2) publish COMPLETED to the tracker (customer sees completed)
      await axios.post(
        `${API_STATUS_BASE}/order/${orderId}/complete`,
        {
          completedAt: new Date().toISOString(),
          fulfillmentType: order?.fulfilmentType,
        },
        { headers: authHeaders(token, appId) }
      );
    } catch (error) {
      console.error('Error completing order:', error);
    }
  };

  // function collectReceiptStrings(order) {
  //   // Only things that appear on the receipt as content (not changing labels)
  //   const labels = [
  //     "Delivery","Pickup" // we keep labels like "Size/Variation" in English to avoid editing HTML
  //   ];

  //   const itemBits = [];
  //   for (const it of order.items || []) {
  //     itemBits.push(it.name);
  //     const size = getSizeLabel(it);
  //     const variation = getVariationLabel(it);
  //     const addons = (getAddonsLabel(it)?.split(/\s*,\s*/g)) || [];
  //     if (size) itemBits.push(size);
  //     if (variation) itemBits.push(variation);
  //     addons.forEach(a => a && itemBits.push(a));
  //   }
  //   return [...new Set([...labels, ...itemBits].filter(Boolean))];
  // }

  // clones the order and swaps only dynamic strings (names, sizes, variations, addons, fulfilment)

  // function applyMap(order, map) {
  //   const tr = (s) => (s && map[s]) ? map[s] : s;
  //   const clone = JSON.parse(JSON.stringify(order));

  //   // fulfilment to Chinese text, but we keep the label "Fulfillment:" in HTML unchanged
  //   const isDelivery = String(order.fulfilmentType || '').toLowerCase() === 'delivery';
  //   clone.fulfilmentType = tr(isDelivery ? "Delivery" : "Pickup");

  //   clone.items = (order.items || []).map((it) => {
  //     const t = { ...it };
  //     t.name = tr(t.name);

  //     // common fields your helpers may read
  //     if (t.sizeName) t.sizeName = tr(t.sizeName);
  //     if (typeof t.size === "string") t.size = tr(t.size);
  //     if (t.variationName) t.variationName = tr(t.variationName);
  //     if (t.selectedVariationName) t.selectedVariationName = tr(t.selectedVariationName);
  //     if (t.crust) t.crust = tr(t.crust);
  //     if (t.base) t.base = tr(t.base);

  //     const addons = t.selectedAddons || t.addons || t.selectedToppings || t.toppings;
  //     if (Array.isArray(addons)) {
  //       const mapped = addons.map((a) => {
  //         if (typeof a === "string") return tr(a);
  //         if (a && typeof a === "object") return { ...a, name: tr(a.name || a.label || a.title) };
  //         return a;
  //       });
  //       if (t.selectedAddons) t.selectedAddons = mapped;
  //       else if (t.addons) t.addons = mapped;
  //       else if (t.selectedToppings) t.selectedToppings = mapped;
  //       else if (t.toppings) t.toppings = mapped;
  //     }
  //     return t;
  //   });

  //   return clone;
  // }




  // Groups items by parentDealId and returns an ordered display model
  const buildDisplayRows = (rawItems = []) => {
    // keep original order index so UI remains predictable
    const indexed = rawItems.map((it, i) => ({ ...it, __i: i }));

    // collect groups keyed by parentDealId
    const groups = new Map();
    for (const it of indexed) {
      if (!it.parentDealId) continue;
      if (!groups.has(it.parentDealId)) {
        groups.set(it.parentDealId, { header: null, children: [], firstIndex: it.__i });
      }
      const g = groups.get(it.parentDealId);
      if (it.isDeal) {
        g.header = it;                      // the priced parent line
        g.firstIndex = Math.min(g.firstIndex, it.__i);
      } else {
        g.children.push(it);                // included lines
        g.firstIndex = Math.min(g.firstIndex, it.__i);
      }
    }

    // build final rows in original order: each deal as one block, plus normal items
    const consumedDealIds = new Set(Array.from(groups.keys()));
    const rows = [];

    // push deal blocks
    const dealBlocks = Array.from(groups.values())
      .sort((a, b) => a.firstIndex - b.firstIndex)
      .map(g => ({ type: 'deal', header: g.header, children: g.children }));

    // push non-deal, non-grouped items
    const singles = indexed
      .filter(it => !it.parentDealId && !it.isDeal)
      .map(it => ({ type: 'item', item: it, index: it.__i }))
      .sort((a, b) => a.index - b.index);

    // merge in correct order by first appearance
    let di = 0, si = 0;
    while (di < dealBlocks.length || si < singles.length) {
      const dIndex = di < dealBlocks.length ? (dealBlocks[di].header?.__i ?? dealBlocks[di].children[0]?.__i ?? Infinity) : Infinity;
      const sIndex = si < singles.length ? singles[si].index : Infinity;
      if (dIndex <= sIndex) rows.push(dealBlocks[di++]);
      else rows.push(singles[si++]);
    }

    return rows;
  };

  // ✅ Place this right here, before handlePrint
  // let generateReceiptHTML accept an optional map of translations
  const generateReceiptHTML = (order, map) => {
    if (!order) return '';

    // translation helper
    const tr = (s) => (map && s && map[s]) ? map[s] : s;

    // escape any '<' so item names don't break HTML
    const safe = (s) =>
      String(s)
        .replaceAll('&', '&amp;')
        .replaceAll('<', '&lt;')
        .replaceAll('>', '&gt;')
        .replaceAll('"', '&quot;')
        .replaceAll("'", '&#039;');

    const isDelivery = String(order.fulfilmentType || '').toLowerCase() === 'delivery';
    const showAddress = isDelivery && order.address;
    const fulfilmentText = tr(isDelivery ? 'Delivery' : 'Pickup');

    // Attempt to access restaurant name from component state
    // const restaurantName = restaurant?.name || '';
    // const restaurantPhone = restaurant?.phone || '';
    // const restaurantAddress = restaurant?.address || '';

    const rows = buildDisplayRows(order.items || []);

    const itemBlocks = rows.map((row) => {
      if (row.type === 'item') {
        const it = row.item;

        const name = tr(it.name);
        // Clean modifiers by safely checking existence
        const sizeRaw = getSizeLabel(it);
        const variationRaw = getVariationLabel(it);
        const addonsRaw = getAddonsLabel(it);

        const modLines = [];
        if (sizeRaw) modLines.push(`Size: ${tr(sizeRaw)}`);
        if (variationRaw) modLines.push(`Variation: ${tr(variationRaw)}`);
        if (addonsRaw) {
          // addonsRaw is typically comma-joined, lets make it readable
          const addonsArr = addonsRaw.split(/\s*,\s*/g).filter(Boolean).map(tr);
          if (addonsArr.length) modLines.push(`Add-ons: ${addonsArr.join(', ')}`);
        }

        const total = money(lineTotal(it));

        return `
          <div style="margin-bottom: 8px; border-bottom: 1px dotted #ccc; padding-bottom: 4px;">
            <div style="font-weight: bold; margin-bottom: 2px;">
              ${it.quantity}x ${safe(name)}
            </div>
            ${modLines.map(m => `<div style="font-size: 0.9em; margin-left: 8px;">- ${safe(m)}</div>`).join('')}
            <div style="text-align: right; margin-top: 2px;">${safe(total)}</div>
          </div>
        `;
      }

      // Deal block
      const parent = row.header || row.children[0];
      const headName = tr(parent?.name ?? 'Meal');
      const headPrice = money(lineTotal(parent));
      const headQty = parent?.quantity ?? 1;

      const childrenHtml = (row.children || []).map((c) => {
        const name = tr(c.name);
        const sizeRaw = getSizeLabel(c);
        const variationRaw = getVariationLabel(c);
        const addonsRaw = getAddonsLabel(c);

        const bits = [];
        if (variationRaw) bits.push(tr(variationRaw));
        if (sizeRaw) bits.push(`Size: ${tr(sizeRaw)}`);
        if (addonsRaw) {
          const addonsArr = addonsRaw.split(/\s*,\s*/g).map(tr);
          bits.push(`+ ${addonsArr.join(', ')}`);
        }

        const suffix = bits.length ? ` — ${bits.join(' | ')}` : '';
        const priceNote = lineTotal(c) > 0 ? money(lineTotal(c)) : 'Included';

        return `<div style="margin-left: 8px; font-size: 0.9em;">- ${safe(name)}${safe(suffix)} (${safe(priceNote)})</div>`;
      }).join('');

      return `
        <div style="margin-bottom: 12px; border-bottom: 1px dotted #ccc; padding-bottom: 6px;">
          <div style="font-weight: bold; margin-bottom: 2px;">
             ${headQty}x ${safe(headName)} — ${safe(headPrice)}
          </div>
          ${childrenHtml}
        </div>
      `;
    });


    const createdAtLabel = order.createdAt
      ? new Date(order.createdAt).toLocaleString('en-GB', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
      })
      : null;


    return `
      <style>
        @media print {
          html, body {
            height: auto !important;
            overflow: visible !important;
            margin: 0;
            padding: 0;
          }
        }
      </style>
      <div style="font-family: monospace; font-size: 16px; width: 220px; padding: 5px; line-height: 1.3; color: black;">
        <div style="height: 10px;"></div>
        
        <div style="text-align: center; border-bottom: 2px solid black; padding-bottom: 5px; margin-bottom: 10px;">
            <div style="font-size: 1.2em; font-weight: bold;">Order #${safe(order.id)}</div>
            ${createdAtLabel ? `<div style="font-size: 0.9em;">${safe(createdAtLabel)}</div>` : ''}
        </div>

        <div style="margin-bottom: 10px;">
            ${order.customer ? `<div><strong>Customer:</strong> ${safe(order.customer)}</div>` : ''}
            ${order.phone ? `<div><strong>Phone:</strong> ${safe(order.phone)}</div>` : ''}
            ${order.address ? `<div><strong>Address:</strong> ${safe(order.address)}</div>` : ''}
            <div><strong>Fulfillment:</strong> ${safe(fulfilmentText)}</div>
        </div>
        
        <hr style="margin: 5px 0; border-top: 1px dashed black;" />
        
        ${itemBlocks.join('')}
        
        <hr style="margin: 5px 0; border-top: 2px solid black;" />

        <div style="display: flex; justify-content: space-between; font-weight: bold; font-size: 1.2em; margin-top: 5px;">
            <span>Total:</span>
            <span>${safe(order.total)}</span>
        </div>
        
        ${order.notes && order.notes.trim() !== ''
        ? `<div style="margin: 15px 0; font-style: italic; white-space: pre-wrap; background: #eee; padding: 5px; border: 1px solid #ccc; text-align: left;"><strong>Notes:</strong><br/>${safe(order.notes)}</div>`
        : ''
      }
      <br />
      <div style="text-align: center; font-size: 0.9em;">Thank you for your order!</div>
      <div style="height: 50px;"></div>
      </div>
    `;
  };


  const printOrder = (order) => {
    if (!order) return;

    // if toggle off -> English only (no map)
    if (!printZh) {
      handlePrint(order, null);
      return;
    }

    // toggle on -> use static zhMap
    handlePrint(order, zhMap);
  };




  const handlePrint = (order, map) => {
    if (!order) return;

    const html = generateReceiptHTML(order, map);
    printJS({
      printable: html,
      type: 'raw-html',
      targetStyles: ['*'],
      documentTitle: `Order #${order?.id || ''}`,
    });
  };




  return (
    <Box
      sx={{
        minHeight: '100vh',
        background: 'linear-gradient(to bottom, #005f73, #0a9396)', // Blue-teal gradient for professionalism
        textAlign: 'center',
        paddingTop: '40px', // Add space between top and content
        p: 2,
      }}
    >
      <audio
        ref={audioRef}
        src="/notify.mp3"
        preload="auto"
        onCanPlayThrough={() => {
          console.log("Audio file loaded!");
        }}
      />


      <Container
        maxWidth="md"
        sx={{
          background: 'linear-gradient(to bottom, white, #f4f4f4)', // Match the background gradient
          borderRadius: '16px',
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', // Soft shadow for consistency
          padding: '20px',
          '@media (max-width: 960px)': { // Tablets
            padding: '15px',
          },

          '@media (max-width: 600px)': { // Mobile
            padding: '10px',
          }
        }}
      >


        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          mb={4}
          sx={{
            flexDirection: 'row',
            '@media (max-width: 600px)': {
              flexDirection: 'column',
              alignItems: 'center', // Center children instead of stretching
              gap: 2,
            },
          }}
        >
          <FormControlLabel
            control={
              <Switch
                checked={isToggled}
                onChange={handleToggle}
                color="primary"
              // Disabled only when trying to turn ON outside hours
              // disabled={!isWithinOpeningHours && !isToggled} 
              />
            }
            label={
              isToggled
                ? 'Close Restaurant'
                : (!isWithinOpeningHours ? 'Closed (outside opening hours)' : 'Open Restaurant')
            }
            sx={{
              marginBottom: '0px',
              '& .MuiTypography-root': {
                fontWeight: 'bold',
                color: isToggled || isWithinOpeningHours ? '#005f73' : '#b91c1c',
                fontSize: '1rem',
                '@media (max-width: 960px)': { fontSize: '0.9rem' },
                '@media (max-width: 600px)': { fontSize: '0.8rem' },
              },
            }}
          />






          <Box display="flex" gap={2}>
            <Button
              variant="outlined"
              onClick={() => setPrepOpen(true)}
              sx={{
                borderColor: '#005f73',
                color: '#005f73',
                fontWeight: 'bold',
                textTransform: 'capitalize',
                borderRadius: '0.75rem',
                padding: '10px 20px',
                '&:hover': {
                  borderColor: '#0a9396',
                  color: '#0a9396',
                  backgroundColor: 'transparent',
                },
              }}
            >
              Prep Times
            </Button>

            <Button
              variant="contained"
              sx={{
                backgroundColor: '#005f73',
                color: 'white',
                fontWeight: 'bold', // Bold font
                textTransform: 'capitalize', // Match button style
                borderRadius: '0.75rem', // Rounded corners
                padding: '10px 20px', // Consistent padding
                '&:hover': {
                  backgroundColor: '#0a9396', // Teal hover effect
                },
              }}
              onClick={handleSignOut} // Trigger sign-out logic
            >
              Sign Out
            </Button>
          </Box>

        </Box>

        {/* Prep times moved to modal */}


        {/* Page Title */}
        <Box textAlign="center"
          mb={4}
          sx={{
            background: 'linear-gradient(to bottom, white, #f4f4f4)',
            padding: '1.5rem'
          }}>
          <h1 style={{
            fontFamily: 'Arial, sans-serif',
            fontWeight: '800',
            fontSize: '3rem',
            lineHeight: '1.25',
            color: 'black',
            marginBottom: '1rem',
            '@media (max-width: 960px)': { // Tablets
              fontSize: '2rem',
            },
            '@media (max-width: 600px)': { // Mobile
              fontSize: '1.5rem',
            }
          }}>
            Order Management
          </h1>
        </Box>
        <TableContainer component={Paper} sx={{
          borderRadius: '0.75rem', // Rounded corners
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', // Soft shadow
          overflow: 'hidden', // Ensure rounded corners clip content
          '@media (max-width: 960px)': { // Tablets
            overflowX: 'auto', // Enable horizontal scrolling
            padding: '10px',
          },

          '@media (max-width: 600px)': { // Mobile
            overflowX: 'scroll', // Allow scrolling
            padding: '5px',
          }

        }}>
          <Table sx={{
            minWidth: '100%',
            background: 'white'
          }}>
            <TableHead sx={{ backgroundColor: '#f3f4f6' }}>
              <TableRow>
                <TableCell />
                <TableCell>Order ID</TableCell>
                <TableCell>Customer</TableCell>
                <TableCell>Time</TableCell>
                <TableCell>Total</TableCell>
                <TableCell>Fulfilment Type</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {orders.map((order, index) => (
                <React.Fragment key={order.id}>
                  <TableRow
                    onClick={() => handleRowClick(order.id)}
                    className={newOrders.includes(order.id) ? 'flash-green' : ''}
                    style={{
                      cursor: 'pointer',
                      backgroundColor: completedOrders.includes(order.id)
                        ? '#e0ffe0'
                        : index % 2 === 0
                          ? '#f9f9f9'
                          : '#fff',
                      color: completedOrders.includes(order.id) ? '#a9a9a9' : 'inherit',
                    }}
                  >





                    <TableCell>
                      <IconButton size="small">
                        {openRow === order.id ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
                      </IconButton>
                    </TableCell>
                    <TableCell sx={{
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      maxWidth: '140px', // Default size

                      '@media (max-width: 960px)': { // Tablets
                        maxWidth: '100px',
                      },

                      '@media (max-width: 600px)': { // Mobile
                        maxWidth: '80px', // Smaller size
                      }
                    }}>{order.id}</TableCell>
                    <TableCell
                      sx={{
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        maxWidth: "140px",

                        "@media (max-width: 960px)": { maxWidth: "100px" },
                        "@media (max-width: 600px)": { maxWidth: "80px" },
                      }}
                    >
                      <div style={{ fontWeight: 600 }}>{order.customer}</div>
                      {order.phone && (
                        <div style={{ fontSize: "12px", color: "#555" }}>{order.phone}</div>
                      )}
                      {order.address && (
                        <div
                          style={{
                            fontSize: "12px",
                            color: "#555",
                            whiteSpace: "normal", // allow wrapping for long addresses
                          }}
                        >
                          {order.address}
                        </div>
                      )}
                    </TableCell>
                    <TableCell>
                      {order.createdAt
                        ? new Date(order.createdAt).toLocaleTimeString('en-GB', {
                          hour: '2-digit',
                          minute: '2-digit',
                        })
                        : '--'}
                    </TableCell>
                    <TableCell sx={{
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      maxWidth: '140px', // Default size

                      '@media (max-width: 960px)': { // Tablets
                        maxWidth: '100px',
                      },

                      '@media (max-width: 600px)': { // Mobile
                        maxWidth: '80px', // Smaller size
                      }
                    }}>{order.total}</TableCell>
                    <TableCell sx={{
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      maxWidth: '140px', // Default size

                      '@media (max-width: 960px)': { // Tablets
                        maxWidth: '100px',
                      },

                      '@media (max-width: 600px)': { // Mobile
                        maxWidth: '80px', // Smaller size
                      }
                    }}>{order.fulfilmentType}</TableCell>
                  </TableRow>

                  <TableRow>
                    <TableCell
                      style={{
                        paddingBottom: 0,
                        paddingTop: 0,
                        backgroundColor: completedOrders.includes(order.id) ? '#f5f5f5' : '#fff', // Grey background for canceled orders
                      }}
                      colSpan={6}
                    >
                      <Collapse in={openRow === order.id} timeout="auto" unmountOnExit>
                        <Box
                          style={{
                            backgroundColor: completedOrders.includes(order.id) ? '#f5f5f5' : '#fff', // Grey for canceled orders
                            color: completedOrders.includes(order.id) ? '#a9a9a9' : 'inherit', // Grey text for canceled orders
                            width: '100%', // Full width
                            width: '100%', // Full width
                            padding: '16px', // Consistent padding
                            margin: 0, // Ensure no extra margin
                            boxSizing: 'border-box', // Include padding in width calculation
                            '@media (max-width: 960px)': { // Tablets
                              padding: '12px',
                            },

                            '@media (max-width: 600px)': { // Mobile
                              padding: '8px',
                            },
                          }}
                        >
                          <strong>Items:</strong>
                          <ul style={{ listStyleType: 'none', padding: 0, margin: 0 }}>
                            {(() => {
                              const rows = buildDisplayRows(order.items || []);
                              if (!rows.length) return <li>No items available</li>;

                              return rows.map((row, i) => {
                                if (row.type === 'item') {
                                  const it = row.item;
                                  return (
                                    <li key={`i-${i}`} style={{ marginBottom: 8 }}>
                                      <strong>{it.quantity}x {it.name}</strong>
                                      <div style={{ marginLeft: 15 }}>
                                        {getSizeLabel(it) && <div>Size: {getSizeLabel(it)}</div>}
                                        {getVariationLabel(it) && <div>Variation: {getVariationLabel(it)}</div>}
                                        {getAddonsLabel(it) && <div>Add-ons: {getAddonsLabel(it)}</div>}
                                        <div>Item Total: {money(lineTotal(it))}</div>
                                      </div>
                                    </li>
                                  );
                                }

                                // deal block
                                const parent = row.header || row.children[0];
                                const dealTitle = parent?.name ?? 'Meal';
                                const dealQty = parent?.quantity ?? 1;
                                const dealPrice = lineTotal(parent);

                                return (
                                  <li key={`d-${i}`} style={{ marginBottom: 10 }}>
                                    <div style={{ fontWeight: 700 }}>
                                      {dealQty}x {dealTitle} <span style={{ fontWeight: 400 }}>— {money(dealPrice)}</span>
                                    </div>

                                    {!!row.children.length && (
                                      <ul style={{ listStyleType: 'disc', margin: '6px 0 0 20px' }}>
                                        {row.children.map((c, idx) => {
                                          const size = getSizeLabel(c);
                                          const variation = getVariationLabel(c);
                                          const addons = getAddonsLabel(c);
                                          const bits = [];
                                          if (variation) bits.push(variation);
                                          if (size) bits.push(`Size: ${size}`);
                                          if (addons) bits.push(`+ ${addons}`);
                                          const suffix = bits.length ? ` — ${bits.join(' | ')}` : '';
                                          return (
                                            <li key={idx}>
                                              {c.name}{suffix}
                                              <span style={{ marginLeft: 6, color: '#666' }}>
                                                {lineTotal(c) > 0 ? money(lineTotal(c)) : 'Included'}
                                              </span>
                                            </li>
                                          );
                                        })}
                                      </ul>
                                    )}
                                  </li>
                                );
                              });
                            })()}
                          </ul>

                          {order.notes && order.notes.trim() !== "" && (
                            <Box
                              mt={2}
                              p={1.5}
                              sx={{
                                backgroundColor: "#fffae5",
                                borderLeft: "4px solid #ffaa00",
                                borderRadius: "6px",
                                fontStyle: "italic",
                                color: "#333",
                                maxWidth: 500,
                                whiteSpace: "pre-wrap",
                                wordBreak: "break-word",
                              }}
                            >
                              <strong>Order Notes:</strong> {order.notes}
                            </Box>
                          )}
                          {!completedOrders.includes(order.id) && (
                            <Box
                              display="flex"
                              gap={1.5}
                              flexWrap="wrap"
                              mt={2}
                              sx={{
                                '& > button': {
                                  // Removed 100% width on mobile to fix elongated look
                                  // Default behavior + flexWrap="wrap" handles it nicely
                                }
                              }}
                            >
                              {/* CREATED -> Accept / Reject */}
                              {order.status === 'CREATED' && (
                                <>
                                  <Button
                                    variant="contained"
                                    color="success"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      setActionOrder(order);
                                      setAcceptOpen(true);
                                    }}
                                  >
                                    Accept
                                  </Button>

                                  <Button
                                    variant="outlined"
                                    color="error"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      setActionOrder(order);
                                      setRejectOpen(true);
                                    }}
                                  >
                                    Reject
                                  </Button>
                                </>
                              )}



                              {/* ACCEPTED -> next depends on flow */}
                              {/* Mark Ready (pickup) - valid for ACCEPTED or DELAYED */}
                              {canMarkReady(order) && (
                                <Button
                                  variant="contained"
                                  color="primary"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    markReady(order);
                                  }}
                                >
                                  Mark Ready
                                </Button>
                              )}

                              {/* Delay - show only when the order is in a state that can be delayed */}
                              {(order.status === "ACCEPTED" || order.status === "DELAYED") && (
                                <Button
                                  variant="outlined"
                                  color="warning"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setActionOrder(order);
                                    setDelayOpen(true);
                                  }}
                                >
                                  Delay
                                </Button>
                              )}


                              {/* Out for Delivery (delivery) - valid for ACCEPTED or DELAYED */}
                              {canOutForDelivery(order) && (
                                <Button
                                  variant="contained"
                                  color="primary"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    markOutForDelivery(order);
                                  }}
                                >
                                  Out for Delivery
                                </Button>
                              )}






                              {/* Complete pickup */}
                              {canCompletePickup(order) && (
                                <Button
                                  variant="contained"
                                  color="success"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleComplete(order.id, order);
                                  }}
                                >
                                  Complete (Picked up)
                                </Button>
                              )}

                              {/* Complete delivery */}
                              {canCompleteDelivery(order) && (
                                <Button
                                  variant="contained"
                                  color="success"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleComplete(order.id, order);
                                  }}
                                >
                                  Complete (Delivered)
                                </Button>
                              )}

                              {/* Always keep your legacy Cancel & Complete visible as a fallback */}
                              {/* <Button
        variant="contained"
        color="warning"
        onClick={(e) => {  e.stopPropagation(); setOrderToCancel(order.id); setIsConfirmOpen(true); }}
      >
        Cancel 
      </Button> */}

                              {/* <Button
        variant="outlined"
        color="success"
        onClick={() => handleComplete(order.id, order)}
      >
        Complete 
      </Button> */}

                              {/* Print always available */}
                              {/* <Button
        variant="contained"
        color="info"
        onClick={() => { setSelectedOrder(order); setTimeout(() => handlePrint(), 100); }}
      >
        Print
      </Button> */}
                              <Button
                                variant="contained"
                                color="info"
                                onClick={(e) => { e.stopPropagation(); printOrder(order) }}
                              >   Print
                              </Button>
                            </Box>
                          )}




                        </Box>
                      </Collapse>






                    </TableCell>
                  </TableRow>
                </React.Fragment>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        {/* Accept dialog (optional readyAt for pickup) */}
        {/* Accept / Ready dialog */}
        <Dialog open={acceptOpen} onClose={closeAccept}>
          <DialogTitle>Accept Order</DialogTitle>

          <DialogContent>
            {actionOrder && isPickup(actionOrder) && (
              <>
                <DialogContentText>
                  Optional pickup ETA (shown to customer):
                </DialogContentText>
                <input
                  type="datetime-local"
                  value={acceptReadyAt}
                  onChange={(e) => setAcceptReadyAt(e.target.value)}
                  style={{ width: '100%', marginTop: 8 }}
                />
              </>
            )}
          </DialogContent>

          <DialogActions>
            <Button onClick={closeAccept}>Cancel</Button>
            <Button variant="contained" onClick={(e) => { e.stopPropagation(); acceptOrder(actionOrder); }}>
              Accept
            </Button>

          </DialogActions>
        </Dialog>



        {/* Reject dialog */}
        <Dialog open={rejectOpen} onClose={closeReject}>

          <DialogTitle>Reject Order</DialogTitle>
          <DialogContent>
            <DialogContentText>Reason (shown to customer):</DialogContentText>
            <textarea
              rows={3}
              value={rejectReason}
              onChange={(e) => setRejectReason(e.target.value)}
              style={{ width: '100%', marginTop: 8 }}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={closeReject}>Close</Button>

            <Button variant="contained" color="error" onClick={(e) => { e.stopPropagation(); rejectOrder(actionOrder) }}>
              Reject
            </Button>
          </DialogActions>
        </Dialog>

        {/* Delay / Out for Delivery / Mark Ready dialog */}
        <Dialog open={delayOpen} onClose={closeDelay}>

          <DialogTitle>Delay Order</DialogTitle>

          <DialogContent>
            <DialogContentText>
              Add extra preparation time (minutes):
            </DialogContentText>

            <input
              type="number"
              min="1"
              value={delayMinutes}
              onChange={(e) => setDelayMinutes(e.target.value)}
              style={{ width: '100%', marginTop: 8 }}
            />
          </DialogContent>

          <DialogActions>
            <Button onClick={closeDelay}>Cancel</Button>
            <Button
              variant="contained"
              color="warning"
              onClick={() => delayOrder(actionOrder)}
              disabled={!delayMinutes || Number(delayMinutes) <= 0}
            >
              Delay
            </Button>
          </DialogActions>
        </Dialog>

        {/* Prep Times Dialog */}
        <Dialog open={prepOpen} onClose={() => setPrepOpen(false)}>
          <DialogTitle>Default Prep Times</DialogTitle>
          <DialogContent>
            <DialogContentText sx={{ mb: 2 }}>
              Set the default preparation times for pickup and delivery orders.
            </DialogContentText>
            <Box display="flex" flexDirection="column" gap={2}>
              <TextField
                type="number"
                label="Pickup (min)"
                value={pickupMinutes}
                onChange={(e) => setPickupMinutes(e.target.value)}
                fullWidth
                slotProps={{ htmlInput: { min: 0 } }}
              />
              <TextField
                type="number"
                label="Delivery (min)"
                value={deliveryMinutes}
                onChange={(e) => setDeliveryMinutes(e.target.value)}
                fullWidth
                slotProps={{ htmlInput: { min: 0 } }}
              />
            </Box>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setPrepOpen(false)}>Cancel</Button>
            <Button
              variant="contained"
              onClick={handleSavePrepTimes}
              disabled={pickupMinutes === '' || deliveryMinutes === ''}
            >
              Save
            </Button>
          </DialogActions>
        </Dialog>



        {/* <Dialog
        open={isConfirmOpen}
        onClose={() => setIsConfirmOpen(false)} // Close the dialog
        PaperProps={{
          sx: {
            borderRadius: '1rem', // Rounded corners
            padding: '1.5rem', // Extra padding
            width: '400px', // Set width
            background: 'linear-gradient(to bottom, white, #f4f4f4)', // Match container background
            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', // Soft shadow for consistency
          },
        }}
      >
        <DialogTitle sx={{ fontWeight: 'bold', fontSize: '1.5rem' }}>Cancel Order</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to cancel this order?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={(e) => {e.stopPropagation(); setIsConfirmOpen(false)}}   sx={{
        color: 'gray',
        textTransform: 'capitalize',
        fontWeight: 'bold', // Consistent bold font
      }}>
            No
          </Button>
       <Button
  onClick={(e) => {
    e.stopPropagation();
    handleCancel(orderToCancel, actionOrder);
    setIsConfirmOpen(false);
    setOrderToCancel(null);
    setActionOrder(null);
  }}
  sx={{ color: 'red', textTransform: 'capitalize', fontWeight: 'bold' }}
>
  Yes, Cancel
</Button>
        </DialogActions>
      </Dialog> */}
      </Container>
      <Box
        sx={{
          textAlign: 'center',
          mt: 4,
          fontSize: '0.8rem',
          color: '#888',
        }}
      >
        © 2025 Grubify ·
        <Button
          variant="text"
          size="small"
          sx={{ color: '#888', textTransform: 'none' }}
          onClick={() => setAboutOpen(true)}
        >
          About
        </Button>
      </Box>
      {soundPromptOpen && (
        <Box
          sx={{
            position: 'fixed',
            top: '20%',
            left: '50%',
            transform: 'translateX(-50%)',
            background: 'linear-gradient(to bottom, #0a9396, #005f73)',
            color: 'white',
            padding: '24px 32px',
            borderRadius: '12px',
            zIndex: 9999,
            boxShadow: '0 8px 20px rgba(0,0,0,0.4)',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            textAlign: 'center',
            width: '90%',
            maxWidth: '480px'
          }}
        >
          <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2 }}>
            Enable sound notifications for new orders?
          </Typography>
          <Box sx={{ display: 'flex', gap: 2 }}>
            <Button
              size="large"
              variant="contained"
              sx={{
                backgroundColor: '#94d2bd',
                color: '#005f73',
                fontWeight: 'bold',
                '&:hover': {
                  backgroundColor: '#76c7b7',
                }
              }}
              onClick={() => {
                audioRef.current?.play().then(() => {
                  setSoundEnabled(true);
                  setSoundPromptOpen(false);
                });
              }}
            >
              Enable
            </Button>
            <Button
              size="large"
              variant="outlined"
              sx={{
                color: '#fff',
                borderColor: '#fff',
                fontWeight: 'bold',
                '&:hover': {
                  backgroundColor: 'rgba(255,255,255,0.1)',
                }
              }}
              onClick={() => {
                setSoundPromptOpen(false);
              }}
            >
              No Thanks
            </Button>
          </Box>
        </Box>

      )}


      <Dialog
        open={aboutOpen}
        onClose={() => setAboutOpen(false)}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: '12px',
            padding: '2rem',
            background: 'linear-gradient(to bottom, white, #f4f4f4)',
          }
        }}
      >
        <DialogTitle sx={{ fontWeight: 'bold', fontSize: '1.5rem' }}>
          About This Application
        </DialogTitle>
        <DialogContent dividers>
          <Typography variant="body1" gutterBottom>
            This application is used for managing restaurant orders.
          </Typography>
          <Box mt={4}>
            <Typography variant="subtitle2">Third-Party Credits:</Typography>
            <Typography variant="body2">
              Notification sound “Ping” by{' '}
              <Link
                href="https://notificationsounds.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                NotificationSounds.com
              </Link>.
            </Typography>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setAboutOpen(false)}>Close</Button>
        </DialogActions>
      </Dialog>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert
          onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
          severity={snackbar.severity}
          sx={{ width: '100%' }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>

      {/* Floating translation toggle - bottom right - only for kungpaopanda domain */}
      {window.location.hostname.includes('kungpao') && (
        <Box
          sx={{
            position: 'fixed',
            bottom: 24,
            right: 24,
            zIndex: 1200,
            backgroundColor: 'white',
            borderRadius: '999px',
            boxShadow: '0 4px 10px rgba(0,0,0,0.2)',
            px: 2,
            py: 1,
            display: 'flex',
            alignItems: 'center',
            gap: 1,
          }}
        >
          <FormControlLabel
            label="Translation"
            labelPlacement="start"
            control={
              <Switch
                checked={printZh}
                onChange={(e) => setPrintZh(e.target.checked)}
                color="primary"
              />
            }
            sx={{
              m: 0,
              '& .MuiTypography-root': {
                fontSize: '0.9rem',
              },
            }}
          />
        </Box>
      )}



    </Box>


  );
};

export default LandingScreen;
